import { __assign } from "tslib";
import React from 'react';
import { getIsShortStatus } from '../../_helpers';
import FeedCardLayout from '../_partials/FeedCardLayout';
import StatusTierPaywall from './StatusTierPaywall';
import ShortStatus from './ShortStatus';
import LongStatus from './LongStatus';
var StatusFeedCardContents = function (props) {
    var className = props.className, deviation = props.deviation, extraActions = props.extraActions, withWatchOrSubscribeButton = props.withWatchOrSubscribeButton;
    var isShortStatus = getIsShortStatus(deviation);
    return (React.createElement(FeedCardLayout, { className: className, deviation: deviation, extraActions: extraActions, isExpandable: !isShortStatus, withWatchOrSubscribeButton: withWatchOrSubscribeButton, withCommentControl: true, withFaveControl: true },
        React.createElement(StatusTierPaywall, { deviation: deviation }, isShortStatus ? React.createElement(ShortStatus, __assign({}, props)) : React.createElement(LongStatus, __assign({}, props)))));
};
StatusFeedCardContents.displayName = 'StatusFeedCardContents';
export default StatusFeedCardContents;
//# sourceMappingURL=Status.js.map